import AdminAddAndEditPollComponent from "../../Components/Admin/AdminAddAndEditPollComponent";
import SideBar from "../../Components/Admin/SideBar";

export default function AdminAddPollsPage() {
  return (
    <AdminAddAndEditPollComponent />
  )
}
